import { HugeiconsIcon } from "@hugeicons/react"
import { ChartLineData01Icon } from "@hugeicons/core-free-icons"

export default function NoData() {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center mb-4">
        <HugeiconsIcon icon={ChartLineData01Icon} size={24} className="text-muted-foreground" />
      </div>
      <h3 className="text-sm font-medium text-foreground mb-1">No data available</h3>
      <p className="text-xs text-muted-foreground max-w-sm">
        No data to display for the selected criteria. Try adjusting your date range or filters.
      </p>
    </div>
  )
}